module.exports = "/_next/static/images/sports-badge-pill-1eb936e42cb92419d7cad1b4aeed10b3.svg";